import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWrench = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.606 2.397a6.16 6.16 0 0 1 3.38-.278q.036.007.07.017a1.83 1.83 0 0 1 1.157 1.036.75.75 0 0 1-.16.825L15.21 6.839a.67.67 0 0 0-.011.924l1.06.948.04.039a.67.67 0 0 0 .969 0l.01-.01 2.846-2.845a.75.75 0 0 1 .922-.11 1.83 1.83 0 0 1 .843 1.227 6.17 6.17 0 0 1-5.403 7.299 6.2 6.2 0 0 1-2.817-.355l-7.41 7.394a2.174 2.174 0 0 1-3.101 0l-.507-.507a2.17 2.17 0 0 1 .001-3.102l7.4-7.33a6.155 6.155 0 0 1 3.554-8.014m6.866 5.27-2.13 2.13a2.173 2.173 0 0 1-3.102.016l-1.063-.951-.035-.034a2.17 2.17 0 0 1 0-3.042l.005-.005 2.242-2.241a4.66 4.66 0 0 0-5.244 4.182 4.66 4.66 0 0 0 .474 2.52.75.75 0 0 1-.143.87l-7.774 7.7a.67.67 0 0 0 0 .961l.006.006.519.518a.673.673 0 0 0 .962 0l.007-.006 7.77-7.753a.75.75 0 0 1 .852-.146 4.674 4.674 0 0 0 6.654-4.725"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWrench;
